import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  channel: () => faker.helpers.arrayElement(['sms', 'email', 'push']),
});
